<div class="flex w-full items-center gap-2 mb-4">
  <app-back-button [url]="'/'" />
  <h1
    class="pr-9 text-3xl max-w-full whitespace-nowrap overflow-hidden lg:text-5xl lg:leading-[120%]"
    id="resetPasswordFormHeading"
  >
    Wachtwoord herstellen
  </h1>
</div>

@if (formState == true) {
  <app-card class="block w-full mt-6 mb-9">
    <p role="status" aria-live="polite">Je wachtwoord is succesvol gewijzigd.</p>
    <p class="mt-4">
      <a routerLink="/" class="inline-flex items-center text-base" aria-label="Inloggen"> Terug naar inloggen </a>
    </p>
  </app-card>
} @else {
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" role="form" aria-labelledby="resetPasswordFormHeading">
    <app-card class="block w-full mt-6 mb-9">
      @if (formState === false) {
        <p class="text-red-500 mb-4" role="alert">
          We konden het wachtwoord niet bijwerken. Mogelijk is de resetcode al gebruikt of ongeldig. Probeer het opnieuw
          of vraag een nieuwe resetlink aan.
        </p>
      }

      <div class="custom-input-container mt-4 w-full custom-input-container--password">
        <label class="custom-label" for="newPassword">Nieuw wachtwoord</label>
        <mat-form-field class="new-password-form-field" appearance="outline">
          <input
            id="newPassword"
            matInput
            type="password"
            formControlName="newPassword"
            placeholder="Jouw nieuwe wachtwoord"
            autocomplete="new-password"
            aria-describedby="newPasswordError"
          />
          <app-password-toggle matSuffix [for]="'newPassword'"></app-password-toggle>
          <mat-error id="newPasswordError" role="alert">
            Het wachtwoord moet voldoen aan de volgende eisen:
            <ul class="list-disc ml-4 mt-1 text-red-600" role="list" aria-label="Wachtwoord vereisten">
              <li role="listitem">Minimaal 6 tekens lang</li>
              <li role="listitem">Minimaal 1 hoofdletter (A-Z)</li>
              <li role="listitem">Minimaal 1 kleine letter (a-z)</li>
              <li role="listitem">Minimaal 1 cijfer (0-9)</li>
              <li role="listitem">
                Minimaal 1 speciaal teken, bijv. <code class="font-mono">! &#64; # $ % ^ &amp; * ( ) _ +</code>
              </li>
            </ul>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="custom-input-container w-full custom-input-container--password">
        <label class="custom-label" for="newPasswordRepeated">Herhaal nieuw wachtwoord</label>
        <mat-form-field appearance="outline">
          <input
            id="newPasswordRepeated"
            matInput
            type="password"
            formControlName="newPasswordRepeated"
            placeholder="Jouw nieuwe wachtwoord"
            autocomplete="new-password"
            aria-describedby="newPasswordRepeatedError"
          />
          <app-password-toggle matSuffix [for]="'newPasswordRepeated'"></app-password-toggle>
          <mat-error id="newPasswordRepeatedError" role="alert">
            De herhaling van het wachtwoord komt niet overeen
          </mat-error>
        </mat-form-field>
      </div>
    </app-card>
    <div class="flex justify-end mb-4">
      <button
        mat-flat-button
        color="accent"
        type="submit"
        [disabled]="resetPasswordForm.invalid || isLoading"
        class="w-full button-large"
      >
        Wijzig wachtwoord
      </button>
    </div>

    <div class="mt-4">
      <app-logo-images></app-logo-images>
    </div>
  </form>
}
